import { useContext, useEffect, useMemo, useState } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { makeUserHasGroupAccess } from '../../../helpers';
import { UserGroup } from '@round/api';

export function useCheckUserGroupsAccess(groups: UserGroup[], hasAccessWhenMatches: 'all' | 'any' = 'all') {
    const [hasAccess, setHasAccess] = useState<Boolean | null>(null);
    const authContext = useContext(AuthContext);
    const userHasGroupAccess = useMemo(
        () => makeUserHasGroupAccess(authContext.user?.groups ?? []),
        [authContext.user?.groups]
    );

    useEffect(() => {
        if (typeof authContext.authenticated !== 'boolean') {
            return;
        }

        if (authContext.authenticated) {
            setHasAccess(userHasGroupAccess(groups, hasAccessWhenMatches));
            return;
        }

        setHasAccess(false);
    }, [hasAccessWhenMatches, groups, userHasGroupAccess, authContext.authenticated]);

    return hasAccess;
}
